

export class StateModel {
    id!: number;
    stateE!: string;
    stateY!: string;
    stateMN!: string;

}